module.exports = __webpack_public_path__ + "2-51.jpg?dc77ebc451ba5bc6c33bdfc90e24951b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-51.jpg
// module id = 128
// module chunks = 0